import clsx from 'clsx';
import React from 'react';

import styles from './GradientBar.module.scss';

export const gradientAnimationColors = [
  '#9EB1FF',
  '#3E63DD',
  '#FF92AD',
  '#E93D82',
  '#29FFDC',
  '#0EB39E',
  '#9EB1FF',
] as const;

export interface GradientBarProps {
  height?: string;
  variant?: 'loop' | 'progress';
  durationMs?: number;
  className?: string;
}

export const GradientBar = ({
  height = '2px',
  variant = 'loop',
  durationMs = 10000,
  className,
}: GradientBarProps) => {
  if (variant === 'progress') {
    return (
      <div
        className={clsx(styles.progressGradientBar, className)}
        style={
          {
            height,
            '--gradient-bar-duration': `${durationMs}ms`,
          } as React.CSSProperties
        }
      />
    );
  }

  return (
    <div className={clsx(styles.gradientBar, className)} style={{ height }} />
  );
};
